import LinkIcon from "@mui/icons-material/Link";
import {
  Alert,
  Button,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useCallback, useRef, useState } from "react";
import parseLocationApi from "../../../infrastructure/api/parseLocation";

const MapLinkInput = ({ onCoordsResolved, disabled = false, size = "small" }) => {
  const [input, setInput] = useState("");
  const [parsing, setParsing] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const debounceRef = useRef(null);

  const resolveInput = useCallback(
    async (value) => {
      const trimmed = value?.trim();
      if (!trimmed) return;

      setParsing(true);
      setError("");
      setSuccess("");

      try {
        const res = await parseLocationApi(trimmed);
        if (res.isSuccess && res.data) {
          const lat =
            res.data.latitude ?? res.data.Latitude ?? null;
          const lng =
            res.data.longitude ?? res.data.Longitude ?? null;
          if (lat != null && lng != null) {
            onCoordsResolved?.({
              xPoint: Number(lat),
              yPoint: Number(lng),
            });
            setSuccess(
              `مختصات: ${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`
            );
          } else {
            setError("مختصات از لینک استخراج نشد.");
          }
        } else {
          setError(res.message || "خطا در پردازش لینک.");
        }
      } catch {
        setError("خطا در ارتباط با سرور.");
      } finally {
        setParsing(false);
      }
    },
    [onCoordsResolved]
  );

  const handleChange = (e) => {
    const value = e.target.value;
    setInput(value);
    setError("");
    setSuccess("");

    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (value?.trim()) {
      debounceRef.current = setTimeout(() => resolveInput(value), 800);
    }
  };

  const handlePaste = (e) => {
    setTimeout(() => {
      const pastedValue = e.target.value;
      if (pastedValue?.trim()) {
        if (debounceRef.current) clearTimeout(debounceRef.current);
        resolveInput(pastedValue);
      }
    }, 50);
  };

  return (
    <>
      <TextField
        fullWidth
        size={size}
        label="لینک نقشه یا مختصات"
        placeholder="لینک گوگل‌مپ، نشان، واتساپ یا lat,lng"
        value={input}
        onChange={handleChange}
        onPaste={handlePaste}
        disabled={disabled}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LinkIcon fontSize="small" />
            </InputAdornment>
          ),
          endAdornment: parsing ? (
            <InputAdornment position="end">
              <CircularProgress size={18} />
            </InputAdornment>
          ) : null,
        }}
        helperText={
          success ||
          (parsing
            ? "در حال بررسی..."
            : "لینک گوگل‌مپ/نشان/واتساپ یا lat,lng را وارد/paste کنید.")
        }
        error={Boolean(error)}
      />
      {error ? (
        <Alert severity="error" sx={{ mt: 0.5, py: 0 }}>
          {error}
        </Alert>
      ) : null}
    </>
  );
};

export default MapLinkInput;
